
export default function DomainAvailability({ isDomainChecking, domainCheckError, deploySuggestions, domainName}) {
  return (
    <div className="domainAvilability">
      {isDomainChecking ? 
        <div className='domain_loading'></div> :
        <div>
          <p className='domainCheckError'>{domainCheckError}</p> 
          {domainCheckError !== "" && <div className="domain_suggestions">
            <p>{
            domainCheckError === "סיומת דומיין לא תקינה!" ? "הדומיין חייב להסתיים באחת מבין האפשרויות הבאות" :
            domainCheckError === `הדומיין ${domainName} אינו זמין.` ? "הנה כמה אפשרויות דומות זמינות" : null}</p>
              <ul>
                  {deploySuggestions()}
              </ul>
          </div>}
        </div>
      }
    </div>
  )
}
